import { defineStore } from 'pinia';
import { useNotificationsStore } from '@/stores/useNotifications';
import useAcvDatadog from '@/composables/useAcvDatadog';
import { notificationKeys } from '@/constants/notificationKeys';

const { addRumError } = useAcvDatadog();

export const useCarrierFleetStore = defineStore('carrierFleetStore', {
  state: () => {
    return {
      fleet: {},
      isEditVehicleSheetOpen: false,
    };
  },
  actions: {
    async getCarrierFleetInfo() {
      const { data, pending, error } = await useAcvFetch(`v1/api/carrier/fleet`);
      if (error.value) {
        return {
          status: error.value.statusCode,
        };
      }
      this.fleet = data.value.data;
      return { fleet: data.value.data, pending };
    },
    async updateCarrierFleetInfo(body) {
      const { $api } = useNuxtApp();
      const notificationsStore = useNotificationsStore();
      let data = null;
      const pending = false;
      let error = null;

      try {
        data = await $api(`v1/api/carrier/fleet/create`, {
          method: 'POST',
          body: body,
        });
      } catch (err) {
        error = err;
      }
      if (error) {
        const customError = new Error('500 update fleet');
        addRumError(customError, body);

        const notificationParams = {
          notificationMessageTemplate:
            '<span class="tw-font-medium">Unable to update fleet info.</span>  Please check connection and try again.',
          variant: 'error',
          key: notificationKeys.errorEditVehicleInfo,
        };
        notificationsStore.addNotification(notificationParams);
        return error;
      }

      const notificationParams = {
        notificationMessageTemplate: 'Fleet information successfully updated.',
        variant: 'success',
        key: notificationKeys.successEditVehicleInfo,
      };
      notificationsStore.addNotification(notificationParams);
      this.fleet = data.data;
      return { fleet: data.data, pending };
    },
  },
  getters: {
    totalFleetCapacity: (state) => state.fleet?.totalFleetCapacity,
    oversizedVehiclesAccepted: (state) => state.fleet?.oversizedVehiclesAccepted,
    hasWinch: (state) => state.fleet?.hasWinch,
    hasFlatbed: (state) => state.fleet?.hasFlatbed,
    hasRollback: (state) => state.fleet?.hasRollback,
    hasEnclosedTrailer: (state) => state.fleet?.hasEnclosedTrailer,
  },
});
